<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="students"
      :hide-default-footer="true"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:[`item.tutor_extra`]="{ item }">
        <invite-tutor
          :item="item"
          :update-student="updateStudent"
          :name-buttom="item.tutor_extra === '' ? 'Invitar Profesor' : item.tutor_extra"
        />
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <details-students
          :id="item.actions.id"
          type-student="parent"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex'
  import DetailsStudents from '@/views/dashboard/pages/panel/DetailsStudents'
  import InviteTutor from '@/views/dashboard/invitations/InviteTutor'

  export default {
    components: {
      DetailsStudents,
      InviteTutor,
    },
    data () {
      return {
        headers: [
          { text: 'Nombre', value: 'details.firstname', aling: 'center', sortable: false },
          { text: 'Apellido', value: 'details.lastname', aling: 'center', sortable: false },

          { text: 'Profesor', value: 'tutor_extra', aling: 'center', sortable: false },
          { text: 'Acciones', value: 'actions', aling: 'center', sortable: false },
          //{ text: 'Grupo', value: 'group', aling: 'center' },
          // { text: 'Promedio global', value: 'average', aling: 'center' },
        ],
        sortBy: 'details.lastname',
        sortDesc: false,
      }
    },
    computed: {
      ...mapState(['userData']),
      students () {
        //return this.userData.students.sort( (a,b ) => a.lastname - b.lastname );
        return this.userData.students
      },
    },
    methods: {
      updateStudent (studentId, tutorExtra) {
        const studentIndex = this.students.findIndex(
          (student) => student.actions.id === studentId,
        )

        this.students[studentIndex].tutor_extra = tutorExtra
      },
    },
  }
</script>
